export default __webpack_public_path__ + "static/media/seoul.431ca4d7.jpg";